module.exports = __webpack_public_path__ + "static/media/pending.2e73c258.svg";